import { InviteUserDto } from "./../dto";
import { AwardingClient } from "@/utils/EvoClient";

const ENDPOINT = "users/c/invite-user";
export default async function inviteUser(dto: InviteUserDto): Promise<void> {
  await AwardingClient.post(ENDPOINT, dto);
}
